import { getApiEnvHost } from './environment';
import type { Env } from './types';

const EXTERNAL_PROTOCOL = 'https://';

export const apiHosts = {
  ACE_API_BASE_HOST: `${EXTERNAL_PROTOCOL}ace-api`,
  API_BASE_HOST: `${EXTERNAL_PROTOCOL}api`,
  AVATAR_API_BASE_HOST: `${EXTERNAL_PROTOCOL}hermes`,
  BOX_API_BASE_HOST: `${EXTERNAL_PROTOCOL}box`,
  CUSTOMIZE_API_BASE_HOST: `${EXTERNAL_PROTOCOL}customize-api`,
  GROWTH_API_BASE_HOST: `${EXTERNAL_PROTOCOL}growth-api`,
  HOMEPAGE_API_BASE_HOST: `${EXTERNAL_PROTOCOL}homepage-api`,
  INVITATION_API_BASE_HOST: `${EXTERNAL_PROTOCOL}invitation-api`,
  LOCALIZATION_API_BASE_HOST: `${EXTERNAL_PROTOCOL}localization-api`,
  LOGIN_API_BASE_HOST: `${EXTERNAL_PROTOCOL}login-api`,
  NAVIGATION_API_BASE_HOST: `${EXTERNAL_PROTOCOL}universal-navigation-api`,
  NEW_MEMBER_API_BASE_HOST: `${EXTERNAL_PROTOCOL}new-member-api`,
  PAYMENT_API_BASE_HOST: `${EXTERNAL_PROTOCOL}payment`,
  QUESTIONNAIRE_API_BASE_HOST: `${EXTERNAL_PROTOCOL}questionnaire`,
  REGISTER_API_BASE_HOST: `${EXTERNAL_PROTOCOL}register-api`,
  REPLENISHMENT_API_BASE_HOST: `${EXTERNAL_PROTOCOL}replenishment-api`,
  REVENUE_API_BASE_HOST: `${EXTERNAL_PROTOCOL}revenue`,
  STOREFRONT_API_BASE_HOST: `${EXTERNAL_PROTOCOL}storefront-api`,
  USER_API_BASE_HOST: `${EXTERNAL_PROTOCOL}user`,
  CONDUCTOR_API_BASE_HOST: `${EXTERNAL_PROTOCOL}conductor`,
  ANALYTICS_API_BASE_HOST: `${EXTERNAL_PROTOCOL}analytics-api`,
  MY_ACCOUNT_API_BASE_HOST: `${EXTERNAL_PROTOCOL}my-account-api`,
  HERMES_API_BASE_HOST: `${EXTERNAL_PROTOCOL}hermes`,
  UNIVERSAL_NAVIGATION_API_BASE_HOST: `${EXTERNAL_PROTOCOL}universal-navigation-api`,
  SUMMER_API_BASE_HOST: `${EXTERNAL_PROTOCOL}summer`,
};

type ApiHosts = keyof typeof apiHosts;

/**
 * Retrieve the available API hosts for the given environment.
 * @description
 * This function takes the environment as parameter and returns
 * the API Hosts for the given environment. It also takes an
 * optional parameter to select the API Hosts to return in
 * cases where just a few are needed.
 */
export function getApiHosts(env: Env, select?: ApiHosts[]) {
  const apiEnvHost = getApiEnvHost(env);

  return Object.entries(apiHosts).reduce(
    (acc, [key, value]) => {
      const typedKey = key as ApiHosts;

      if (select && !select.includes(typedKey)) {
        return acc;
      }

      acc[typedKey] = `${value}.${apiEnvHost}`;
      return acc;
    },
    {} as Record<ApiHosts, string>,
  );
}
